import { useQueryClient } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { getHotelsQueryOptions } from "@/hooks/hotels";
// import { useGetAccommodations } from "@/hooks/accommodations";
import { getClientsQueryOptions } from "@/hooks/clients";
import { getDepartmentsQueryOptions } from "@/hooks/departments";
import { getGuidesQueryOptions } from "@/hooks/guides";
// import { useGetHotelRooms } from "@/hooks/hotel-rooms";
import { getAgenciesQueryOptions } from "@/hooks/agencies";
import { getProvidersQueryOptions } from "@/hooks/providers";
import { getRegionsQueryOptions } from "@/hooks/regions";
// import { useGetReservationClients } from "@/hooks/reservation-clients";
// import { useGetReservationDays } from "@/hooks/reservation-days";
import { getReservationsQueryOptions } from "@/hooks/reservations";
import { getServicesQueryOptions } from "@/hooks/services";
// import { useGetTourAccommodations } from "@/hooks/tour-accommodations";
// import { useGetTourAgencies } from "@/hooks/tour-agencies";
// import { useGetTourDays } from "@/hooks/tour-days";
// import { useGetTourServices } from "@/hooks/tour-services";
import { getToursQueryOptions } from "@/hooks/tours";
import { getWorkersQueryOptions } from "@/hooks/workers";

export function usePreloadData() {
  const [progress, setProgress] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const queryClient = useQueryClient();

  useEffect(() => {
    const preload = async () => {
      try {
        // Example preload sequence with progress
        const steps = [
          queryClient.prefetchQuery(getHotelsQueryOptions),
          // useGetAccommodations();
          queryClient.prefetchQuery(getClientsQueryOptions),
          queryClient.prefetchQuery(getDepartmentsQueryOptions),
          queryClient.prefetchQuery(getGuidesQueryOptions),
          // useGetHotelRooms();
          queryClient.prefetchQuery(getAgenciesQueryOptions),
          queryClient.prefetchQuery(getProvidersQueryOptions),
          queryClient.prefetchQuery(getRegionsQueryOptions),
          // useGetReservationClients();
          // useGetReservationDays();
          queryClient.prefetchQuery(getReservationsQueryOptions),
          queryClient.prefetchQuery(getServicesQueryOptions),
          // useGetTourAccommodations();
          // useGetTourAgencies();
          // useGetTourDays();
          // useGetTourServices();
          queryClient.prefetchQuery(getToursQueryOptions),
          queryClient.prefetchQuery(getWorkersQueryOptions),
        ];

        for (let i = 0; i < steps.length; i++) {
          await steps[i];
          setProgress((i + 1) / steps.length);
        }
      } finally {
        setIsLoading(false);
      }
    };
    preload();
  }, [queryClient]);

  return { isLoading, progress };
  }